export enum CommonActionTypes {
  GET_BRANCH_LIST = 'getBranchList',
  GET_STORE_FACILITIES = 'getStoreFacilities',
  GET_CERTIFICATE_LIST = 'getCertificateList'
}

export enum CourseActionTypes {
  /**获取预约次课筛选结果*/
  GET_SCREEN_SINGLE = 'getScreenSingle',
}
